export const SUPABASE_SKILLS_TABLE_NAME =
    import.meta.env.MODE === 'development' ? 'dev_skills' : 'prod_skills';

export const SUPABASE_EXPERIENCES_TABLE_NAME =
    import.meta.env.MODE === 'development'
        ? 'dev_experiences'
        : 'prod_experiences';

export const SUPABASE_RESUMES_TABLE_NAME =
    import.meta.env.MODE === 'development' ? 'dev_resumes' : 'prod_resumes';

export const SUPABASE_COVER_LETTERS_TABLE_NAME =
    import.meta.env.MODE === 'development'
        ? 'dev_cover_letters'
        : 'prod_cover_letters';

export const SUPABASE_EDUCATION_TABLE_NAME =
    import.meta.env.MODE === 'development' ? 'dev_education' : 'prod_education';

export const SITE_NAME = 'ResumeSupercharged';

export const UNQUALIFIED_ERROR =
    'It appears the skills and experience you have provided may not align with the needs of this role. Please add any missing skills or experience from your repertoire and try again. If you truly believe you are qualified, click "I am qualified" below.';
